import * as yup from 'yup';

export const signInFormSchema = yup.object().shape({
  email: yup
    .string()
    .required('Digite um e-mail válido')
    .email('Digite um e-mail válido'),
  password: yup.string().required('Senha obrigatória'),
});
